import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import colorfulAnimation from '../../assets/animations/dashboard-loading.json';
import styles from '@/styles/features/auth/auth-pages.module.css';

/**
 * Full-page card loader shown during auth / app initialization.
 * Displays a white card with the Lottie animation. The wordmark is the dark
 * variant because the card is white — the light one would be invisible.
 */
const CardLoader = ({ message = 'Please wait while we log you in.' }) => {
  return (
    <div
      className={`fixed inset-0 flex justify-center items-center overflow-hidden ${styles.appBackground}`}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.25 }}
        className="w-[470px] h-[338px] tertiary-bg rounded-lg flex flex-col justify-center items-center gap-2"
      >
        <img
          src="/opus-wordmark-dark.png"
          alt="Opus Capital Markets Consultants"
          className="h-10 w-auto object-contain"
        />

        <div className="w-56 h-56 -mt-14 -mb-14">
          <Lottie
            animationData={colorfulAnimation}
            loop
            className={styles.fullSizeLottie}
          />
        </div>

        <p className={`p-sm-regular text-black mt-0 ${styles.brandText}`}>
          {message}
        </p>
      </motion.div>
    </div>
  );
};

export default CardLoader;
